import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { XCircle } from 'lucide-react';
import { ServisfyLogo } from '../Common/ServisfyLogo';
import { useLanguage } from '../../contexts/LanguageContext';

const SignupCancel = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-white via-green-50 to-purple-50">
      <Card className="w-full max-w-lg backdrop-blur-sm bg-white/90 border-0 shadow-xl">
        <CardHeader>
          <div className="flex justify-center mb-3"><ServisfyLogo variant="full" size="lg" /></div>
          <CardTitle className="text-center text-2xl">{t('cancel.title')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <XCircle className="h-16 w-16 mx-auto text-amber-500" />
          <p className="text-gray-700">{t('cancel.desc')}</p>
          <Button
            onClick={() => navigate('/signup')}
            className="w-full bg-gradient-to-r from-green-500 to-purple-600"
            data-testid="signup-cancel-retry-btn"
          >
            {t('success.backToSignup')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default SignupCancel;